module.exports = __webpack_public_path__ + "static/HelveticaNeueLTPro-Roman-75bad3c04c8bc26f6cfedd147f3756b5.woff";